import { Flex } from 'antd';
import { Dialogs as DialogsModule } from '@modules/dialogs';
import styles from './dialogs.module.scss';

export const Dialogs = () => (
  <Flex className={styles.root}>
    <DialogsModule />
  </Flex>
);
